import { useRouter } from '@tanstack/react-router'
import { ErrorPage } from '@/components/shared/error-page'
import { useAuthStore } from '@/store/auth'

export default function NotFound() {
  const router = useRouter()
  const organizationId = useAuthStore((s) => s.organizationId)

  if (!organizationId) {
    return (
      <ErrorPage
        statusCode={404}
        title='Page introuvable'
        description="La page que vous recherchez n'existe pas ou a été déplacée."
        actions={[
          {
            label: 'Se connecter',
            onClick: () => router.navigate({ to: '/login' }),
          },
        ]}
      />
    )
  }

  return (
    <ErrorPage
      statusCode={404}
      title='Page introuvable'
      description="La page que vous recherchez n'existe pas ou a été déplacée."
      actions={[
        {
          label: 'Retour au tableau de bord',
          onClick: () =>
            router.navigate({
              to: '/org/$orgId/dashboard',
              params: { orgId: organizationId },
            }),
        },
        {
          label: 'Page précédente',
          variant: 'outline',
          onClick: () => router.history.back(),
        },
      ]}
    />
  )
}
